import { useEffect, useState } from 'react';
import { getPayments } from '../../lib/use-cases/get-payments';

function usePayments() {
    const [payments, setPayments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getData = async () => {
        const list = await getPayments();

        setPayments(list);
        setIsLoading(false);
    };

    useEffect(() => {
        getData();
    }, []);

    return {
        payments,
        isLoading
    };
}

export {
    usePayments
};
